module.exports = "<p>\n  mass-messenger-entity-selector-form works!\n</p>\n"